import React, { useRef, useState } from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { TStepProps } from './types';

import Box from '../../Global/Atomics/Box';
import { Button } from '../../Global/Atomics/Button';
import { Paragraph } from '../../Global/Atomics/Paragraph';
import CustomIcon from '../../Global/Icons/CustomIcon';

import { useReportFormContext } from '../../../contexts/ReportFormContext';
import { useResponsiveContext } from '../../../contexts/ResponsiveContext';
import { mediaUp } from '../../../styles/Shared/MediaQueries';

const Wrapper = styled(Box)`
    position: relative;    

   .image-backdrop {
        height: 0;
        top: 0;
        opacity: 0;
        z-index: -1;
        transform: scale(0);
        transition: transform .3s ease-out;
    }

    &:hover {
        .image-backdrop {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            left:0;
            width: 100%;
            height: 282px;
            background-color: rgba(0,0,0,0.5);
            border-radius: 8px;
            transform: scale(1);
            opacity: 1;
            z-index: 1;
           cursor: pointer;

           ${mediaUp.medium} {
                height: 500px;
            }
        }
    }
`;

const StyledUploadButton = styled.button<{ isValid: boolean }>`
    width: 100%;
    height: 282px;
    background-color: white;
    border: ${({ theme, isValid }) => `1.5px solid ${!isValid ? theme.color['error-4'] : theme.color['coolgray-2']}`};
    border-radius: 8px;
    cursor: pointer;

    ${mediaUp.medium} {
        height: 500px;
    }
`;

const StyledUploadImage = styled.img`
    object-fit: cover;
    width: 100%;
    height: 282px;
    border-radius: 8px;
    cursor: pointer;

    ${mediaUp.medium} {
        height: 500px;
    }
`;

type TProps = TStepProps & {
    handleSubmit: (formData: object) => void
};

const Step3 = ({ handleSubmit, resources }: TProps) => {
    const inputRef = useRef<any>(null);
    const [viewMode] = useResponsiveContext();
    const { form, updateForm } = useReportFormContext()
    const [fileIsValid, setFileIsValid] = useState(true);

    const fileSelectedHandler = (event: any) => {
        // @ts-ignore
        let fileExtension = document?.getElementById('img-input')?.value.split('.').pop().toLowerCase();
        var allowedExtension = ['jpeg', 'jpg', 'png', 'gif', 'bmp'];
        var isValidFile = false;

        for (var index in allowedExtension) {
            if (fileExtension === allowedExtension[index]) {
                isValidFile = true;
                break;
            }
        }

        if (isValidFile) {
            var reader = new FileReader();
            let file = event.target.files[0];
            reader.readAsDataURL(file);

            reader.onload = function () {
                setFileIsValid(true);
                updateForm({ field: form.image.id, value: { base64: reader.result, file: event.target.files[0] } });
            };
            reader.onerror = function () {
                console.log(`Couldn't encode image`);
            };
        } else {
            if (form.image.value.base64 && fileExtension !== '') {
                setFileIsValid(false);
                updateForm({ field: form.image.id, value: { base64: '', file: '' } });
            }
        }
    };

    return (
        <>
            <Box mt="lg" mb="sm" pb="xs">
                <Paragraph typography="text-s-bold" customColor="black-1">{resources.report.step3.title}</Paragraph>
            </Box>

            {/* UPLOAD IMAGE */}
            <Row center="xs">
                <Col xs={12} md={8}>
                    <Wrapper mb={fileIsValid ? 'lg' : 'sm'} alignItems="center">
                        <input id="img-input" type="file" onChange={fileSelectedHandler} style={{ display: 'none' }} ref={inputRef} accept="image/*" />
                        {(!form.image.value.file) && (
                            <StyledUploadButton onClick={() => inputRef.current.click()} isValid={fileIsValid}>
                                <Box display="flex" flexDirection="column" alignItems="center">
                                    <CustomIcon icon="CameraIcon" customColor={fileIsValid ? "green-nova" : "error-4"} />
                                    <Paragraph typography="ui-s-medium" customColor={fileIsValid ? "green-nova" : "error-4"} mt="lg">{resources.label.uploadPhoto}</Paragraph>
                                </Box>
                            </StyledUploadButton>
                        )}
                        {(form.image.value.file) && (
                            <>
                                <StyledUploadImage
                                    alt="img"
                                    onClick={() => inputRef.current.click()}
                                    width={'250px'}
                                    src={form.image.value.file ? URL.createObjectURL(form.image.value.file) : ''}
                                />
                                {viewMode === 'desktop' && (
                                    <Box className="image-backdrop" onClick={() => inputRef.current.click()}>
                                        <Box display="flex" flexDirection="column" alignItems="center">
                                            <CustomIcon icon="CameraIcon" customColor="white" />
                                            <Paragraph typography="ui-s-medium" customColor="white" mt="lg">{resources.label.uploadPhoto}</Paragraph>
                                        </Box>
                                    </Box>
                                )}
                            </>

                        )}
                    </Wrapper>
                    {!fileIsValid && (
                        <Box mb="lg">
                            <Paragraph typography='ui-s' customColor='error-4'>{resources.report.step3.warningMessage}</Paragraph>
                        </Box>
                    )}
                </Col>
            </Row>
            {/* size="m" variant="primary-black" onClick={() => handleSubmit(form)} disabled={!form.image.value.file}>
                        {resources.label.reportIncident} */}
            {/* CTA */}
            <Row center="xs">
                <Col>
                    <Button size="m" variant="primary-black" onClick={() => handleSubmit(form)}>
                        {resources.label.reportIncident}
                    </Button>
                </Col>
            </Row>
        </>
    );
};

export default React.memo(Step3);